<template>
  <v-app>
    <core-app-bar v-if="['Login'].indexOf($route.name)"/>

    <core-drawer v-if="['Login'].indexOf($route.name)"/>

    <core-view/>

    <!--<core-footer />-->
  </v-app>
</template>

<script>
export default {
  components: {
    CoreDrawer: () => import('@/components/core/Drawer'),
    CoreFooter: () => import('@/components/core/Footer'),
    CoreAppBar: () => import('@/components/core/AppBar'),
    CoreView: () => import('@/components/core/View')
  }
}
</script>
<style>
.v-dialog > .v-card > .v-card__title {
  background-color: #009fe3;
  color: white;
  height: 70px;
  cursor: move;
}

.v-dialog > .v-card > .v-card__title > .headline {
  cursor: default;
}

.v-data-table-header__icon {
  color: #fff !important;
}

.v-data-table .v-data-table__wrapper table thead tr {
  vertical-align: top !important;
}

.v-data-table th {
  padding-top: 2px !important;
}

.v-progress-linear {
  margin-top: -2px !important;
  background-color: #ed1c24 !important;
}

.v-data-table tr:hover {
  background: #1f1f1f !important;
}

.v-data-table td {
  font-size: 0.75rem !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.v-data-footer {
  background-color: #1f1f1f;
}

.v-menu__content {
  min-width: 5% !important;
}

.swal2-popup {
  background-color: #313131 !important;
}
.swal2-info {
  border-color: #fff !important;
  color: #ffffff !important;
}

.swal2-title {
  color: #ffffff !important;
}

.swal2-confirm {
  background-color: #00669b !important;
  color: #fff !important;
}

.swal2-content {
  color: #dadada !important;
}
</style>
